import React from 'react';
import PropTypes from 'prop-types';

import {FormControl, FormHelperText, InputLabel, Select} from "@mui/material";
import shortid from "shortid";
import InputBase from "../InputBase";
import GF from "../../../../../lib/utils/GF";

class InputDropDown extends InputBase {

  constructor(props) {
    super(props);
    this.labelId = shortid();
  }

  getValue() {
    return this.inputElementRef.current.value;
  }

  onChange = (event) => {
    this.fireOnChange(event, event.target.value);
  }

  render() {
    let {fullWidth, defaultValue = '', value, children, labelElement, width, disabled} = this.props;
    fullWidth = fullWidth !== false;
    const hasError = !!this.state.errorText;
    return <FormControl size={this.props.size} fullWidth={fullWidth} sx={{width: width}} required={GF.getValue(
      this.props.required, false)} error={hasError}>
      <InputLabel id={this.labelId}>{labelElement}</InputLabel>
      <Select
        variant="outlined"
        inputRef={this.inputElementRef}
        labelId={this.labelId}
        id={this._id}
        disabled={disabled}
        defaultValue={defaultValue}
        value={value}
        label={labelElement}
        onChange={(e) => { this.clearError(); this.onChange(e); }}
        onBlur={(e) => this.onBlur(e.target.value)}>
        {children}
      </Select>
      {hasError && <FormHelperText>{this.state.errorText}</FormHelperText>}
    </FormControl>
  }
}

InputDropDown.propTypes = {
  className: PropTypes.string,
  labelElement: PropTypes.any,
  helpTextElement: PropTypes.node,
  state: PropTypes.oneOf(['none', 'enable', 'disable', 'error', 'readonly']),
  defaultValue: PropTypes.any,
  value: PropTypes.any,
  disabled: PropTypes.bool,
  with: PropTypes.number,
  onChange: PropTypes.func,
  color: PropTypes.oneOf(['primary', 'secondary', 'light', 'dark']),
  required: PropTypes.bool
}
export default InputDropDown;
